import newsItems from "./newsItems.js"

import { Link } from "react-router-dom"; // Make sure React Router is set up

const NewsContent = () => {
  return (
    <div className="container my-5">
      <h1 className="mb-4 fw-semibold text-secondary text-center">
        Latest News
      </h1>

      <div className="row">
        {newsItems.map((item) => (
          <div key={item.id} className="col-12 col-md-6 col-lg-4 mb-4">
            <div className="card h-100 shadow-sm border-0">
              <img
                src={item.image}
                className="card-img-top"
                alt={item.title}
                style={{
                  height: "250px",
                  objectFit: "cover",
                  objectPosition: "top",
                }}
              />
              <div className="card-body d-flex flex-column">
                <h5 className="card-title">{item.title}</h5>
                <p className="card-text text-muted mb-2">{item.date}</p>
                <p className="card-text">{item.content[0]}</p>

                <div className="mt-auto">
                  <Link
                    to={`/news/${item.id}`}
                    className="btn btn-outline-secondary"
                  >
                    Read More
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewsContent;
